var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0002 20C15.5231 20 20.0002 15.5228 20.0002 10C20.0002 4.47715 15.5231 0 10.0002 0C4.4774 0 0.000244141 4.47715 0.000244141 10C0.000244141 15.5228 4.4774 20 10.0002 20ZM10.7537 3.951C10.4459 3.32068 9.55504 3.32068 9.24669 3.951H9.24611L7.68641 7.14241L4.19896 7.65393C3.50981 7.75576 3.2345 8.61024 3.73296 9.10186L6.25712 11.5857L5.66129 15.0931C5.54363 15.7861 6.26407 16.3152 6.88077 15.9874L9.99959 14.3311L13.1202 15.9874C13.7363 16.3146 14.4573 15.7861 14.3391 15.0931L13.7432 11.5857L16.2674 9.10186C16.7658 8.61082 16.4911 7.75518 15.8014 7.65393L12.3139 7.14241L10.7537 3.951Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.a80dd36a.svg";
export { ForwardRef as ReactComponent };